import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/cut-circle.png'


const _hoisted_1 = { class: "todays-schedule-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "calendar" }
const _hoisted_5 = { class: "header d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-medium text-black" }
const _hoisted_7 = { class: "weekdays text-center" }
const _hoisted_8 = { class: "days text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "blank-day"
}
const _hoisted_11 = { class: "events-list position-relative scrollbar" }
const _hoisted_12 = { class: "d-block text-black fw-semibold" }
const _hoisted_13 = { class: "user d-flex align-items-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "d-block fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Today's Schedule")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args))),
              class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_left", -1)
            ]))]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.monthNames[_ctx.currentMonth]) + " " + _toDisplayString(_ctx.currentYear), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
              class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_right", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (day) => {
              return (_openBlock(), _createElementBlock("div", { key: day }, _toDisplayString(day), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysInMonth, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["card border-0 mx-auto text-black fw-medium border-radius", { 'current-day': _ctx.isToday(day) }])
              }, [
                (day !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(day), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, " "))
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "event-item card border-0 border-radius position-relative z-1"
            }, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(event.time), 1),
              _createElementVNode("p", null, _toDisplayString(event.description), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: event.user.image,
                  alt: "user-image",
                  class: "rounded-circle"
                }, null, 8, _hoisted_14),
                _createElementVNode("span", _hoisted_15, _toDisplayString(event.user.name), 1)
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"info d-flex align-items-center justify-content-between\" data-v-5037ed92><button type=\"button\" class=\"btn btn-primary\" data-v-5037ed92> View Details </button><button type=\"button\" class=\"notification-btn p-0 border-0 rounded-circle\" data-v-5037ed92><i class=\"ri-notification-2-line\" data-v-5037ed92></i></button></div><div class=\"shape position-absolute z-n1 end-0 top-0\" data-v-5037ed92><img src=\"" + _imports_0 + "\" alt=\"cut-circle\" data-v-5037ed92></div>", 2))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}